import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CfetBaseComponent } from '../../../cfet-core';

@Component({
    selector: 'app-customer-eligibility-utf-completion',
    templateUrl: './customer-eligibility-utf-completion.component.html',
    styleUrls: ['./customer-eligibility-utf-completion.component.scss'],
    standalone: false
})
export class CustomerEligibilityUtfCompletionComponent extends CfetBaseComponent implements OnInit {

  signupComplete: any;
  selectedCategory: string;
  selectedRole: string;
  @Output() signupDoneStatus = new EventEmitter<any>();
  @Output() showCancelModal = new EventEmitter<any>();
  @Input() stateAndZip: any;
  constructor() { super(); }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {
    this.selectedCategory = sessionStorage.getItem('selectedCategory');
    this.selectedRole = sessionStorage.getItem('selectedRole');
    const orgData = sessionStorage.getItem('orgDetailInfo');
    const manualData = sessionStorage.getItem('StoreManulValues');
    if (orgData) {
      this.stateAndZip = JSON.parse(orgData);
    } else if (manualData) {
      const data = JSON.parse(manualData);
      this.stateAndZip = {
        org_name: data.name,
        address: data.Address1,
        city: data.City,
        state: data.State,
        zipcode: data.Zip
      };

    }
  }

  signup(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.signupComplete = true;
      this.signupDoneStatus.emit(true);
    }
  }

  cancelsignupCreation(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showCancelModal.emit(true);
    }
  }

  goToBackStep(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.signupComplete = false;
      this.signupDoneStatus.emit(false);
    }
  }

}

